import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { Skeleton } from '@/components/ui/skeleton'

const DetailsCaseDetails = lazy(
	() =>
		import('@/features/air/case-management/components/details/case-details'),
)

export const Route = createFileRoute(
	'/_dashboard/air/case-management/$id/case-details',
)({
	head: ({ params }) => ({
		meta: [
			{
				title: `Case Details · Case ${params.id} | Case Management | BitLyft AIR®`,
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()

	return (
		<ErrorBoundary
			feature="case-management"
			section="case-details"
			entityId={id}
		>
			<Suspense fallback={<Skeleton className="h-96 w-full" />}>
				<DetailsCaseDetails id={id} />
			</Suspense>
		</ErrorBoundary>
	)
}
